<template>
  <div>
    <b-navbar>
      <b-container>

      <button class="menu" @click="handleToggleMenu()" v-if="logged">
        <Menu title="Menu" />
      </button>

      <NavbarBrand />

      <NavbarMenu />

      <b-navbar-nav class="ml-auto side-right" v-if="logged">
        <NavbarConnectedLabel
          :message="labelMessage"
          v-if="labelMessage"
        />

        <NavbarConfigurations
          v-if="userProfile.admin"
          :handleShowNotifications="handleShowNotifications"
        />

        <NavbarNotifications
          :showNotifications="showNotifications"
          :handleShowNotifications="handleShowNotifications"
        />

        <NavbarAccount
          :handleShowNotifications="handleShowNotifications"
        ></NavbarAccount>
      </b-navbar-nav>

      </b-container>
    </b-navbar>

    <NavbarSubMenu />
  </div>
</template>

<script>
import ProfileMixin from '@/modules/Application/mixins/ProfileMixin';
import { mapActions, mapState } from 'vuex';
import Menu from 'vue-material-design-icons/Menu';
import NavbarBrand from './NavbarBrand';
import NavbarSubMenu from './NavbarSubMenu';
import NavbarMenu from './NavbarMenu';
import NavbarNotifications from './NavbarNotifications';
import NavbarAccount from './NavbarAccount';
import NavbarConfigurations from './NavbarConfigurations';
import NavbarConnectedLabel from './NavbarConnectedLabel';

export default {
  components: {
    NavbarSubMenu,
    NavbarMenu,
    NavbarBrand,
    NavbarNotifications,
    NavbarConfigurations,
    NavbarAccount,
    Menu,
    NavbarConnectedLabel,
  },
  props: ['logged', 'labelMessage'],
  name: 'Navbar',
  mixins: [ProfileMixin],
  computed: {
    ...mapState('application', [
      'menus',
      'openMenu',
      'defaultRoute',
      'toggleMenu',
      'showNotifications',
    ]),
  },
  methods: {
    ...mapActions('application', [
      'handleOpenMenu',
      'handleSelectMenu',
      'handleShowNotifications',
      'handleToggleMenu',
    ]),
  },
};
</script>
